export const constants = {
  BASE_URL: 'https://api.yenikargo.az/',
  // BASE_URL: 'http://localhost:5000/',
};
